import { createAction, props } from '@ngrx/store';
import { Product, Category, Occasion } from '../../app/shared/interface/home';

export const showLoader = createAction('[Products] Show Loader');
export const hideLoader = createAction('[Products] Hide Loader');

export const loadProducts = createAction('[Products] Load Products');
export const loadProductsSuccess = createAction(
  '[Products] Load Products Success',
  props<{ products: Product[] }>()
);
export const loadProductsFailure = createAction(
  '[Products] Load Products Failure',
  props<{ error: string }>()
);

export const loadCategories = createAction('[Products] Load Categories');
export const loadCategoriesSuccess = createAction(
  '[Products] Load Categories Success',
  props<{ categories: Category[] }>()
);
export const loadCategoriesFailure = createAction(
  '[Products] Load Categories Failure',
  props<{ error: string }>()
);

export const loadOccasions = createAction('[Products] Load Occasions');
export const loadOccasionsSuccess = createAction(
  '[Products] Load Occasions Success',
  props<{ occasions: Occasion[] }>()
);
export const loadOccasionsFailure = createAction(
  '[Products] Load Occasions Failure',
  props<{ error: string }>()
);

// Reset all filters and products
export const resetProducts = createAction('[Products] Reset All');

// Multi-select filter action
export const filterProducts = createAction(
  '[Products] Filter Products',
  props<{ selectedCategories: string[]; selectedOccasions: string[] }>()
);
export const filterByRating = createAction(
  '[Products] Filter By Rating',
  props<{ rating: number }>()
);

export const setFilters = createAction(
  '[Products] Set Filters',
  props<Partial<{
    keyword: string;
    minPrice: number | null;
    maxPrice: number | null;
    minRate: number;          
    categories: string[];
    occasions: string[];
  }>>()
);











